async function AddEductorSelection(edcutorid, designid) {

    if (true) {

        let response;

        let params = {
            "@EductorID": edcutorid,
            "@DesignID": designid,
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "84",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);
    }
}

export default AddEductorSelection;